import styled from 'styled-components';

export const GraphContainer = styled.div`
  flex-grow: 1;
`;
